export default __webpack_public_path__ + "static/media/fluster_lobby_background_large.d1cf10e5.png";